module.exports = __webpack_public_path__ + "img/hy_tjhby.836df6a5.svg";